import { useForm } from 'react-hook-form';
import useToast from '@sdk/common/toast/useToast';
import getErrorForToast from '@sdk/api/utils/getErrorForToast';

import { useAddTaskTemplate } from '@web/shiftTasks/hooks/useAddTaskTemplate';
import { TaskTemplateFormValues } from '@web/shiftTasks/ComposeTask/types/TaskTemplateFormValues';
import { getTaskTemplatePayload } from '@web/shiftTasks/utils/mappers';

import { Props } from './AddTaskTemplate';

const defaultTemplate = {
  title: '',
  subtasks: [{ title: '' }],
  attachments: [],
};

export function useAddTaskTemplateForm({ modalState, onSubmitSuccess, sourceTemplate }: Props) {
  const addTaskTemplateMutation = useAddTaskTemplate();
  const defaultValues = sourceTemplate ? sourceTemplate : defaultTemplate;
  const formMethods = useForm<TaskTemplateFormValues>({
    defaultValues,
  });
  const { showErrorToast } = useToast();

  const { close } = modalState;
  const onSubmit = async (data: TaskTemplateFormValues) => {
    try {
      const payload = getTaskTemplatePayload(data, true);
      const result = await addTaskTemplateMutation.mutateAsync(payload);
      onSubmitSuccess?.(result);
      close();
    } catch (e) {
      showErrorToast(getErrorForToast(e));
    }
  };

  return {
    formMethods,
    onSubmit,
  };
}
